/**
 * Links for the FPN and FULAFIA project
 */

export default {
  api: 'https://portal.fpn.edu.ng/api',
  // api: 'http://localhost:8080/api'
};
